import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import { DeterminateProgress } from './DeterminateProgress'

export const DeterminateLoading = ({ message, value }) => {
    let msg = message ? message : 'Loading...'

    return (
        <Box
            sx={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Typography color="neutral" level="body-lg">
                {msg}
            </Typography>
            <DeterminateProgress value={value} />
        </Box>
    )
}
